import { Switch as UISwitch } from "@webmotors/eleanor-ui";

type VariantProps =
  | "primary"
  | "inactive"
  | "active"
  | "error"
  | "warning"
  | "complementary";
export interface SwitchProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
  checked?: boolean;
  dataQA?: string;
  disabled?: boolean;
  label?: string;
  labelSide?: "left" | "right";
  name?: string;
  variant?: VariantProps;
}

export function Switch({
  checked = false,
  dataQA,
  disabled = false,
  label,
  labelSide = "right",
  name,
  variant = "primary",
  ...props
}: Readonly<SwitchProps>) {
  return (
    <UISwitch
      checked={checked}
      dataQA={dataQA}
      disabled={disabled}
      label={label}
      labelSide={labelSide}
      name={name}
      variant={variant}
      {...props}
    />
  );
}
